import {connect} from 'react-redux';
import Home from '../../../components/home/Home';

export default connect(_ => ({}), {})(Home);
